export default __webpack_public_path__ + "static/media/PNG.504a232c.svg";